export const turnToArrForThree = (target: number) => {
    return [target, target, target];
};
